<template>
    <div class="steptext">
        <span class="step-message" style="margin-bottom: -10px" v-if="step.pretitle" v-html="step.pretitle"/>
        <span class="step-message">
           {{ step.message }}
        </span>
        <span class="step-message">
            <strong v-if="step.todo"
                    :class="[step.todo && step.todo === 'ON' ? 'mode-on' : step.todo && step.todo === 'OFF' ? 'mode-off' : 'mode-others']">
                <span v-html="step.todo"/>
            </strong>
        </span>
    </div>
</template>

<script>
export default {
    name: "StepText",
    props: ['step'],
}
</script>

<style scoped lang="less">

.mode-on {
    color: darkturquoise;
}

.mode-off {
    color: orangered;
}

.step-message {
    font-size: 16px;

    /* Small only */
    @media screen and (max-width: 599px) {
        font-size: 12px;
    }

    /* Medium only */
    @media screen and (min-width: 600px) and (max-width: 1264px) {
        font-size: 14px;
    }
}

.steptext {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
}


</style>
